export default __webpack_public_path__ + "static/media/photo--sm--112.b5953109.jpg";